import absoluteUrl from './absoluteUrl';

export const getVimeoVideo = async (videoId, signal) => {
  try {
    const resp = await fetch(absoluteUrl() + '/api/vimeo-video', {
      signal: signal,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        videoId
      })
    });

    const json = await resp.json();

    return json;
  } catch (err) {
    if (err.name === 'AbortError') {
      return { aborted: true };
    } else {
      throw err;
    }
  }
};

export const selectVimeoSource = sources => {
  const target = window.innerWidth * window.devicePixelRatio;
  // during dev always return smallest source
  //const target = 320

  // for selfhosted videos as in the case of DRL
  if (!Array.isArray(sources)) {
    return sources;
  }
  let selected = sources.sort((a, b) => {
    return Math.abs(target - a.width) - Math.abs(target - b.width);
  })[0];
  return selected.link_secure;
};

export default getVimeoVideo;
